import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getDictionaryProofsByOwnerOptions } from '@/module/Author/Dictionary/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface DictionaryOwnerProofListProps {
  dictionaryId: Id;
  userId: Id;
}

export function DictionaryOwnerProofList({ dictionaryId, userId }: DictionaryOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getDictionaryProofsByOwnerOptions(dictionaryId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="dictionary"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
